/** Result messages of applying analysis suggestions (lib/analysis.ts, lib/time-suggestions.ts). */
export const analysisMessagesEn = {
  analysisMessages: {
    logged: "Logged",
    logFailed: "Couldn't log this time.",
    rejectFailed: "Couldn't reject this proposal.",
    ideaCreated: "Idea created",
    pickProjectWi: "Pick a project for this work item.",
    hotfixCreated: "Hotfix created",
    bugCreated: "Bug created",
    taskCreated: "Task created",
    wiCreated: "Work item created",
    pickTargetComment: "Pick a target ticket for the comment.",
    commentAdded: "Comment added",
    pickTarget: "Pick a target ticket.",
    pickAssignee: "Pick who takes it over.",
    assignedTo: "Assigned to {{name}}",
    assigneeUpdated: "Assignee updated",
    priorityUpdated: "Priority updated",
    fixedPriceSet: "Fixed price set",
    estimateUpdated: "Estimate updated",
    approveStatus: "Approve this suggestion to apply the status change.",
    nothingToMerge: "Nothing to merge.",
    mergeFailed: "Couldn't merge these items.",
    merged: "Merged {{count}} duplicate(s) into the kept item",
    alreadyMerged: "Already merged",
    specConflict:
      "The spec changed since this rewrite was written, in the part it rewrites. Write it again against the current spec.",
    specChanged: "Specification changed",
    specExtended: "Specification extended",
    notSaved: "This suggestion isn't saved yet.",
    movedTo: "Moved to {{status}}",
    statusFailed: "Couldn't change the status.",
  },
};
export const analysisMessagesCs: typeof analysisMessagesEn = {
  analysisMessages: {
    logged: "Zapsáno",
    logFailed: "Tento čas se nepodařilo zapsat.",
    rejectFailed: "Tento návrh se nepodařilo zamítnout.",
    ideaCreated: "Nápad vytvořen",
    pickProjectWi: "Vyberte projekt pro tuto pracovní položku.",
    hotfixCreated: "Hotfix vytvořen",
    bugCreated: "Bug vytvořen",
    taskCreated: "Úkol vytvořen",
    wiCreated: "Pracovní položka vytvořena",
    pickTargetComment: "Vyberte cílový tiket pro komentář.",
    commentAdded: "Komentář přidán",
    pickTarget: "Vyberte cílový tiket.",
    pickAssignee: "Vyberte, kdo to převezme.",
    assignedTo: "Přiřazeno: {{name}}",
    assigneeUpdated: "Řešitel aktualizován",
    priorityUpdated: "Priorita aktualizována",
    fixedPriceSet: "Pevná cena nastavena",
    estimateUpdated: "Odhad aktualizován",
    approveStatus: "Schvalte tento návrh, aby se změna stavu provedla.",
    nothingToMerge: "Není co sloučit.",
    mergeFailed: "Tyto položky se nepodařilo sloučit.",
    merged: "Sloučeno duplicit: {{count}} do zachované položky",
    alreadyMerged: "Již sloučeno",
    specConflict:
      "Zadání se od napsání tohoto přepisu změnilo v části, kterou přepis mění. Napište ho znovu proti aktuálnímu zadání.",
    specChanged: "Zadání změněno",
    specExtended: "Zadání rozšířeno",
    notSaved: "Tento návrh ještě není uložen.",
    movedTo: "Přesunuto do stavu {{status}}",
    statusFailed: "Stav se nepodařilo změnit.",
  },
};
